import { BodyText } from '@/components/BodyText';
import { useSupportedFileTypes } from '@/hooks/useSupportedFileTypes';
import { Box, Button, TableBody } from '@mui/material';
import { FILE_FORMATS } from '@physna/supported-files';
import {
  StyledTable,
  StyledTableHeadRow,
  StyledTableHeadCell,
  StyledTableRow,
  StyledTableCell,
  TableHead,
} from './HelpTable';

export const FileTypesView = ({ onBack }: { onBack?: () => void }) => {
  const { allExtensions } = useSupportedFileTypes();
  const tableData = Object.entries(FILE_FORMATS).filter(([, format]) =>
    format.extensions.some(extension => allExtensions.includes(extension))
  );

  return (
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
      {onBack && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '12px' }}>
          <Button variant='text' onClick={onBack}>
            Back
          </Button>
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <StyledTable size='small'>
          <TableHead>
            <StyledTableHeadRow>
              <StyledTableHeadCell>Format</StyledTableHeadCell>
              <StyledTableHeadCell>Extensions</StyledTableHeadCell>
              <StyledTableHeadCell>Version</StyledTableHeadCell>
            </StyledTableHeadRow>
          </TableHead>
          <TableBody>
            {tableData.map(([key, format], index) => (
              <StyledTableRow key={key} isEven={index % 2 !== 0}>
                <StyledTableCell>
                  <BodyText color='text.primary'>{format.format}</BodyText>
                </StyledTableCell>
                <StyledTableCell>
                  <BodyText color='text.primary'>
                    {format.extensions.filter(extension => allExtensions.includes(extension)).join(', ')}
                  </BodyText>
                </StyledTableCell>
                <StyledTableCell>
                  <BodyText color='text.primary' sx={{ whiteSpace: 'pre-line' }}>
                    {format.version}
                  </BodyText>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </StyledTable>
      </Box>
    </Box>
  );
};
